import { DataTableDto, DataTableQuery, DataTableQueryType, DataTableReference } from 'src/app/services/api.services';
import { deepClone } from 'src/app/shared/clone/cloner-service';
import { INamedElement, NamedElementHierarchyCollection } from './Collections';
import { DataField } from './DataField';
import { DataSource } from './DataSource';
import { mapToRecord } from '../utils/mapToRecord';

export class DataTable implements INamedElement {
  readonly fields = new DataTable.FieldCollection(this);

  constructor(
    public readonly source: DataSource,
    public readonly reference: DataTableReference) { }

  get model() { return this.source.model; }

  get name() { return this.reference.table; }


  query: DataTableQuery = {
    type: DataTableQueryType.CalculatedTable,
  };

  readonly additionalProperties = new Map<string, any>();

  setFromDto1(dto: DataTableDto) {
    this.query = deepClone(dto.query);

    for (let [k, v] of Object.entries(dto.additionalProperties)) {
      this.additionalProperties.set(k, deepClone(v));
    }

    dto.fields.forEach(x => this.fields.add(x.name).setFromDto1(x));
  }

  setFromDto2(dto: DataTableDto) {
    dto.fields.forEach(x => this.fields.get(x.name).setFromDto2(x));
  }

  toDto(): DataTableDto {
    return {
      name: this.name,
     
      fields: [...this.fields.map(x => x.toDto())],
      query: deepClone(this.query),
      
      additionalProperties: mapToRecord(this.additionalProperties),
    };
  }
}

export namespace DataTable {
  export class FieldCollection extends NamedElementHierarchyCollection<DataField> {
    constructor(public readonly t: DataTable) {
      super();
    }

    add(name: string) {
      let item = new DataField(this.t, name);
      this._add(item);
      return item;
    }

    getOrAdd(name: string) {
      return this.find(name) ?? this.add(name);
    }

    protected findChild(item: DataField, name: string) {
      return item.children.find(name);
    }

    protected getBase() { return this.t.model.base?.tables.find(this.t.reference)?.fields; }
    protected getExtensions() { return this.t.model.base?.extensions.map(x => x.tables.find(this.t.reference)?.fields) ?? []; }
  }
}
